module.exports = __webpack_public_path__ + "static/media/juniorBadge.592cfac8.png";